import radToDeg from '%paysera_seat_selection/js/seatSelection/services/radToDeg';

const invertNegativeDegrees = degrees => (degrees >= 0 ? degrees : 360 + degrees);

function isUpsideDown(rads) {
    const angle = invertNegativeDegrees(radToDeg(rads) % 360);
    return angle > 90 && angle < 270;
}

export default isUpsideDown;
